export const regEx = /[^${}]+(?=})/g;

export const getReplacerRegex = (item: string): RegExp => new RegExp(
  (`\${${item}}`).replace(/[-/\\^$*+?()|[\]{}]/g, "\\$&"), "gi",
);

export const onlyUnique = (value: string, index: number, self: string[]): boolean => self.indexOf(value) === index;